import { Apps } from 'src/constants/App';
import type { OrderVm } from 'src/types/OrderVm';

export function isManualOrder(order: OrderVm): boolean {
    return order.app === Apps.PIDEDIRECTOADMIN || order.app === Apps.LETSEATMANAGER; // remove  || order.app === Apps.LETSEATMANAGER when Apps.PIDEDIRECTOADMIN is used instead of Apps.LETSEATMANAGER everywhere
}
